import React from "react";
import ReactMarkdown from "react-markdown";

const CASE_REPORT_SECTIONS = [
  { field: "summary", titleKey: "query.b2cSummary" },
  { field: "next_steps", titleKey: "query.b2cNextSteps" },
  { field: "questions_for_doctor", titleKey: "query.b2cQuestions" },
  { field: "red_flags", titleKey: "query.b2cRedFlags" },
  { field: "consensus", titleKey: "query.b2cConsensus" },
  { field: "disagreements", titleKey: "query.b2cDisagreements" },
];

function plainCaseSummary(item) {
  const text = (item?.case_summary || "")
    .replace(/\[[A-Z][A-Z0-9_]*_\d+\]/g, " ")
    .replace(/\*\*/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  if (!text || text === "—") return "";
  return text;
}

function summaryWithoutRepeatedTitle(summary, caseSummary) {
  const text = (summary || "").trim();
  if (!text || !caseSummary) return text;
  const parts = text.split(/\n\s*\n/).filter((part) => part.trim());
  const first = parts[0].replace(/\*\*/g, " ").replace(/\s+/g, " ").trim();
  if (first === caseSummary) {
    return parts.slice(1).join("\n\n").trim();
  }
  return text;
}

export function CaseReportSections({ query, t }) {
  if (!query) return null;
  const caseSummary = plainCaseSummary(query);
  const sections = {
    ...query,
    summary: summaryWithoutRepeatedTitle(query.summary, caseSummary),
  };
  const present = CASE_REPORT_SECTIONS.filter((section) => (sections[section.field] || "").trim());
  return (
    <>
      {caseSummary ? (
        <div data-testid="history-case-summary">
          <p className="text-xs font-medium text-muted-foreground uppercase mb-1">
            {t("history.caseSummary")}
          </p>
          <p className="text-sm bg-muted/50 p-3 rounded-sm">{caseSummary}</p>
        </div>
      ) : null}
      {present.length > 0 ? (
        present.map((section) => (
          <div key={section.field} data-testid={`history-section-${section.field}`}>
            <p className="text-xs font-medium text-muted-foreground uppercase mb-1">
              {t(section.titleKey)}
            </p>
            <div className="text-sm bg-muted/50 p-3 rounded-sm prose prose-sm max-w-none">
              <ReactMarkdown>{sections[section.field]}</ReactMarkdown>
            </div>
          </div>
        ))
      ) : query.synthesis_response ? (
        <div>
          <p className="text-xs font-medium text-muted-foreground uppercase mb-1">
            {t("history.synthesis")}
          </p>
          <p className="text-sm bg-muted/50 p-3 rounded-sm whitespace-pre-wrap">
            {query.synthesis_response}
          </p>
        </div>
      ) : null}
    </>
  );
}
